<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div>
    <header class="home-header wrap" :class="{'active' : headerScroll}">
      <img class="logo" src="@/assets/logo.png" />
      <van-field v-model="value" placeholder="搜索" />
    </header>
    <nav-bar />
    <div v-if="isShow.banner" class="swiperWrap">
      <swiper style="height: 100%; border-radius: 10px;" :list="swiperList"></swiper>
    </div>
    <p class="title title1"></p>
    <div v-if="isShow.nav" class="autoBox" style="padding-bottom: 12px">
      <div class="category-list category-list2">
        <div v-for="(item, index) in category" v-bind:key="index" @click="tips">
          <img :src="item.cover">
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
    <div v-if="isShow.shop">
      <p class="title">限时购</p>
      <div class="category-list1" style="justify-content: normal">
        <div v-for="item in productList" v-bind:key="item.categoryId" @click="tips">
          <img :src="item.picture">
          <span class="name">{{item.name}}</span>
          <p class="price"><span class="priceActive">¥<span style="font-size: 14px">{{item.price}}</span></span></p>
        </div>
      </div>
    </div>
    <div class="list">
      <div v-if="isShow.goods" style="width: 50%">
        <p class="title">匠人好物</p>
        <div class="category-list1">
          <div style="width: 45%" v-for="item in goods" v-bind:key="item.id" @click="onClick(item.id)">
            <img :src="item.picture">
            <p class="name">{{item.name}}</p>
            <p class="price" style="margin-top: 4px"><span class="priceActive">¥<span style="font-size: 14px">{{item.price}}</span></span></p>
          </div>
        </div>
      </div>
      <div v-if="isShow.group" style="width: 50%">
        <p class="title">拼团</p>
        <div class="category-list1">
          <div style="width: 45%" v-for="item in group" v-bind:key="item.id" @click="onClick(item.id)">
            <img :src="item.picture">
            <p class="name">{{item.name}}</p>
            <p class="price" style="margin: 4px 0 0;text-align: left"><span class="priceActive">¥<span style="font-size: 14px">{{item.price}}</span></span></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShow.hotel" class="good">
      <p class="title" style="display: flex; justify-content: space-between">
        <span>酒店推荐</span>
        <span style="color: #333; font-size: 12px; margin-right: 16px">查看更多 &gt;</span>
      </p>
      <div class="good-box good-box1">
        <div class="good-item" v-for="(item, index) in house" :key="index">
          <i v-for="(node, num) in item.images" :key="num">
            <img :src="node">
          </i>
          <div class="good-desc">
            <div class="title name">{{ item.house_name }}</div>
            <p class="price" style="margin: 4px 0 0"><span class="priceActive">¥<span style="font-size: 14px">{{item.basic_price}}</span></span></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShow.travel">
      <p class="title">网红景点</p>
      <div class="autoBox">
        <div class="category-list category-list3">
          <div v-for="item in place" v-bind:key="item.id" @click="tips">
            <img :src="item.src">
            <div class="detial">
              <p class="placeTitle">{{item.title}}</p>
              <p>{{item.detial}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background: #F9F9F9;height: 30px"></div>
    <ul v-if="isShow.notice" class="lastList">
      <li v-for="(val, index) in contentList" :key="index">
        <p class="top">
          <span class="name">员工【{{val.publisher}}】{{val.title}}</span>
          <span style="color: #999">{{val.create_at}}</span>
        </p>
        <p class="content">
          <foldText :introduce="val.details"></foldText>
        </p>
      </li>
    </ul>
    <div v-if="isShow.list" class="good" style="padding-bottom: 80px; background: #f9f9f9">
      <Goods :shopType="shopType" />
    </div>
  </div>
</template>

<script>
import FoldText from "./overflow/Overflow";
import { ref, reactive, onMounted, toRefs, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import swiper from '@/components/Swiper'
import navBar from '@/components/NavBar'
import Goods from "./goods/Goods";
import { getHome, getCate, getProduct, getNotice, getModule } from '@/service/home'
export default {
  name: 'home',
  components: {
    swiper,
    navBar,
    FoldText,
    Goods
  },
  setup() {
    const active = ref(0);
    const router = useRouter()
    const state = reactive({
      // 轮播图列表
      swiperList: [],
      // 精选列表
      category: [],
      // 限时购
      productList: [],
      // 匠人好物
      goods: [],
      // 拼团
      group: [],
      // 酒店推荐
      house: [],
      // 网红景点
      place: [
        {
          id: '1',
          title: '赤朗沟咖啡屋',
          detial: '高原上最孤独的咖啡屋',
          src: 'http://zhangqian91hr.oss-cn-shanghai.aliyuncs.com/%E5%92%96%E5%95%A1%E5%B1%8B5d64f7b3-d8f2-43ac-a1f8-a24fb4e49c56.jpg',
        },
        {
          id: '2',
          title: '琼穆岗嘎雪山 ',
          detial: '念青唐古拉山脉南端最高峰',
          src: 'http://zhangqian91hr.oss-cn-shanghai.aliyuncs.com/%E9%9B%AA%E5%B1%B163d11983-b34d-407d-a4aa-fc7594e13250.jpg',
        },
        {
          id: '3',
          title: '尼木温泉驿站 ',
          detial: '',
          src: 'http://zhangqian91hr.oss-cn-shanghai.aliyuncs.com/%E6%B8%A9%E6%B3%8955243570-ac4e-471f-87e8-d798b16f51a3.jpg',
        },
        {
          id: '4',
          title: '尼木日措湿地景区 ',
          detial: '风光旖旎，山水如画',
          src: 'http://zhangqian91hr.oss-cn-shanghai.aliyuncs.com/%E6%B9%BF%E5%9C%B090cb97be-62f5-4ee6-8c7e-caf434b4ab5d.jpg',
        }
      ],
      // 日志列表
      notice: [],
      // 搜索内容
      value: '',
      contentList: [],
      // 模块显示与否
      isShow: {
        nav: false,
        banner: false,
        shop: false,
        goods: false,
        group: false,
        hotel: false,
        travel: false,
        notice: false,
        list: false
      },
      // isLogin: false, // 是否已登录
      headerScroll: false, // 滚动透明判断
      loading: true
    })
    const shopType = ref('is_new')
    onMounted(async () => {
      const { data } = await getHome()
      const cate = await getCate()
      const param = {
        page: '1',
        is_seckilling: true
      }
      let param1 = {
        page: '1',
        is_recommend: true
      }
      let param2 = {
        page: '1',
        is_pt: true
      }
      const data1 = await getProduct(param1)
      const data22 = await getProduct(param2)
      const data2 = await getModule()
      JSON.parse(data2.data.default_value).forEach(item => {
        if(item.name === '顶部商品导航栏' && !item.disabled) {
          state.isShow.nav = true
        } else if(item.name === 'banner图' && !item.disabled) {
          state.isShow.banner = true
        } else if(item.name === '匠人好物' && !item.disabled) {
          state.isShow.goods = true
        } else if(item.name === '限时购' && !item.disabled) {
          state.isShow.shop = true
        } else if(item.name === '超值拼团' && !item.disabled) {
          state.isShow.group = true
        } else if(item.name === '酒店模块' && !item.disabled) {
          state.isShow.hotel = true
        } else if(item.name === '风景板块' && !item.disabled) {
          state.isShow.travel = true
        } else if(item.name === '日报模块' && !item.disabled) {
          state.isShow.notice = true
        } else if(item.name === '商品展示' && !item.disabled) {
          state.isShow.list = true
        }
      })
      const product = await getProduct(param)
      const notice = await getNotice()
      state.contentList = notice.data
      state.swiperList = data.banner
      state.category = cate.data
      state.goods = data1.data
      state.group = data22.data
      state.house = data.house
      state.productList = product.data
      // state.notice = notice.data
      // const token = getLocal('token')
      /* if (token) {
        state.isLogin = true
        // 获取购物车数据.
        // store.dispatch('updateCart')
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      // console.log(data);
      state.swiperList = data.carousels
      state.newGoodses = data.newGoodses
      state.hots = data.hotGoodses
      state.recommends = data.recommendGoodses */
      // state.loading = false
      // Toast.clear()
    })

    nextTick(() => {
      window.addEventListener('scroll', () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        scrollTop > 100 ? state.headerScroll = true : state.headerScroll = false
      })
    })

    const goToDetail = (item) => {
      router.push({ path: `/product/${item.goodsId}` })
    }

    function onClick(id) {
      router.push({path: '/good/details', query: {id: id}})
    }

    const tips = () => {
      // Toast('敬请期待');
    }

    return {
      active,
      onClick,
      shopType,
      ...toRefs(state),
      goToDetail,
      tips
    }
  },
}
</script>

<style lang="less" scoped>
  @import '../common/style/mixin';
  .home-header {
      position: fixed;
      align-items: center;
      left: 0;
      top: 0;
      .wh(100%, 50px);
      .fj();
      line-height: 50px;
      padding: 0 15px;
      .boxSizing();
      justify-content: left;
      font-size: 15px;
      color: #fff;
      background: #8C211B;
      z-index: 10000;
      .logo{
        width: 34px;
        height: 34px;
        margin-right: 10px;
        border-radius: 50%;
      }
      .van-cell{
        height: 30px;
        width: 80%;
        border-radius: 30px;
        line-height: 30px;
        padding: 0 20px;
      }
      .nbmenu2 {
        color: @primary;
      }

      .header-search {
          display: flex;
          .wh(74%, 20px);
          line-height: 20px;
          margin: 10px 0;
          padding: 5px 0;
          color: #232326;
          background: rgba(255, 255, 255, .7);
          border-radius: 20px;
          .app-name {
              padding: 0 10px;
              color: @primary;
              font-size: 20px;
              font-weight: bold;
              border-right: 1px solid #666;
          }
          .icon-search {
              padding: 0 10px;
              font-size: 17px;
          }
          .search-title {
              font-size: 12px;
              color: #666;
              line-height: 21px;
          }
      }
      .icon-iconyonghu{
        color: #fff;
        font-size: 22px;
      }
      .login {
        color: @primary;
        line-height: 52px;
        .van-icon-manager-o {
          font-size: 20px;
          vertical-align: -3px;
        }
      }
  }
  .swiperWrap{
    width: 92%;
    height: 120px;
    padding: 50px 4% 0;
    background: #8C211B;
  }
  .title{
    color: #8C211B;
    background: #F9F9F9;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    padding: 10px 0 10px 16px;
  }
  .title1{
    border-radius: 16px 16px 0 0;
    margin-top: -16px;
  }
  .autoBox{
    overflow-x: auto;
  }
  .category-list {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    padding-bottom: 8px;
    div {
      display: flex;
      flex-direction: column;
      margin: 0 6px;
      text-align: center;
      img {
        .wh(46px, 46px);
        background: #C6EBFC;
        border-radius: 50%;
        padding: 12px 0 0 12px;
        margin: 13px auto 8px auto;
      }
    }
  }
  .category-list1 {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: space-between;
    margin: 0 16px;
    padding: 13px 0;
    img{
      display: block;
      height: 70px;
      margin: 0 auto;
    }
    div {
      display: flex;
      flex-direction: column;
      width: 20%;
      margin-right: 10px;
      text-align: center;
    }
    .name{
      display: inline-block;
      width: 94%;
      margin: 6px 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .price{
      color: #999;
      font-size: 12px;
      margin-bottom: 0;
      .priceActive{
        color: red;
        font-weight: bold;
        margin-right: 6px;
      }
    }
  }
  .category-list1::-webkit-scrollbar,
  .autoBox::-webkit-scrollbar,
  .good-box1::-webkit-scrollbar{display:none}
  .category-list2{
    div{
      img{
        .wh(40px, 40px);
        padding: 0 10px;
        background: transparent;
      }
    }
  }
  .category-list3{
    div{
      position: relative;
      img{
        border-radius: 20px;
        .wh(220px, 160px);
        padding: 0;
        background: transparent;
      }
      .detial{
        position: absolute;
        text-align: left;
        bottom: 10px;
        left: 20px;
        color: #fff;
      }
      .placeTitle{
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 0;
      }
    }
  }
  .list{
    display: flex;
  }
  .good {
    .good-header {
      background: #f9f9f9;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: @primary;
      font-size: 16px;
      font-weight: 500;
    }
    .good-box {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      background: #f9f9f9;
      .good-item {
        box-sizing: border-box;
        width: 48%;
        padding: 10px 10px 0;
        background: #fff;
        border-radius: 10px;
        img {
          display: block;
          width: 120px;
          margin: 0 auto;
        }
        .good-desc {
          text-align: center;
          font-size: 14px;
          padding: 4px 0 12px;
          .title {
            color: #222333;
            background: #fff;
            margin: 0;
            text-align: left;
            font-weight: normal;
            font-size: 12px;
            padding: 0;
          }
          .name{
            width: 90%;
            margin: 6px 0 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .price {
            display: flex;
            justify-content: space-between;
            margin-top: 6px;
            color: red;
            font-weight: bold;
          }
          .addIcon{
            display: inline-block;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: red;
            border-radius: 50%;
          }
        }
      }
    }
    .good-box1{
      flex-wrap: nowrap;
      overflow-x: auto;
      justify-content: normal;
    }
  }
  .floor-list {
      width: 100%;
      padding-bottom: 50px;
      .floor-head {
        width: 100%;
        height: 40px;
        background: #F6F6F6;
      }
      .floor-content {
        display: flex;
        flex-shrink: 0;
        flex-wrap: wrap;
        width: 100%;
        .boxSizing();
        .floor-category {
          width: 50%;
          padding: 10px;
          border-right: 1px solid #dcdcdc;
          border-bottom: 1px solid #dcdcdc;
          .boxSizing();
          &:nth-child(2n) {
            border-right: none;
          }
          p {
            font-size: 17px;
            color: #333;
            &:nth-child(2) {
              padding: 5px 0;
              font-size: 13px;
              color: @primary;
            }
          }
          .floor-products {
            .fj();
            width: 100%;
            img {
              .wh(65px, 65px);
            }
          }
      }
    }
  }
  .lastList{
    padding: 0 16px 5px;
    background: #f9f9f9;
    li{
      padding: 12px 20px;
      min-height: 100px;
      margin-bottom: 20px;
      background: #fff;
      border-radius: 10px;
      .top{
        display: flex;
        padding-bottom: 8px;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        .name{
          font-weight: bold;
          font-size: 16px;
        }
      }
      .content{
        margin-bottom: 0;

      }
    }
  }
</style>
